<template>
  <div>
    <div>
      <v-layout wrap>
        <v-flex md6 sm12 lg4 v-for="(script, index) in contentScripts" :key="index">
          <v-card style="min-height:140px" color="#363636" dark>
            <v-card-title style="font-size: 23px;">{{script.campaignName}}</v-card-title>
            <v-card-text class="pt-5">
              <div class="text-center">
                <v-btn :to="'/influencers/content-storyboard/'+script.pairingID" target="_blank" color="warning" right>Edit Content Storyboard Flow</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
    <v-divider></v-divider>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </div>
</template>

<script>
// import config from '@/config';
// import campaignAPIs from '../../Campaign/campaignAPIs';
import pairingAPIs from '../pairingAPIs'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: 'creator-concept-form',
  components: { Loading },
  data() {
    return {
      isLoading: false,
      contentScripts: [] // List content scripts
    };
  },
  computed: {
    influencerID: function() {
      return this.$store.state.user.influencerID;
    }
  },
  mounted() {
    this.fetchPairingByInf();
  },
  methods: {
    fetchPairingByInf() {
      this.isLoading = true
      pairingAPIs
        .getContentScriptByinfID(this.influencerID) // In future, Campaign status could be change
        .then(response => {
          this.isLoading = false
          for (let resp of response) {
            this.contentScripts.push(resp)
          }
        })
        .catch(err => {
          console.log('Error:' + err);
          this.isLoading = false
        });
    }
  }
};
</script>
<style lang="scss">
.campaing-infor {
  background: #076585; /* fallback for old browsers */
  background: -webkit-linear-gradient(to bottom, #076585, #fff); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to bottom, #076585, #fff); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}
.campaign-post {
  a:link,
  a:visited {
    color: white !important;
    background-color: transparent;
    text-decoration: none;
  }
}
.igPost-block {
  overflow: scroll;
  max-width: 350px;
  max-height: 350px;
}
</style>



// WEBPACK FOOTER //
// List.vue?0742103b